import FinishScriptForm from "./OTCScriptForm";

export default FinishScriptForm;
